import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';


export function PageEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["title"]} children={children} />
    );
}

export function PageCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"page"} children={children} />
    );
}
